import React, { useEffect, useState } from 'react';
import { useAuth } from '../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { useLoading } from '../../commons/Loading';
import { Link, Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Footer from '../../commons/Footer';
import {
  Button,
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
} from 'reactstrap';
import {
  BtnRadiusWhite,
  ContFlexLeft,
  H4Styled,
} from '../../styled-components';
import { ReactComponent as IconBack } from '../../images/icn-back.svg';
import classNames from 'classnames';
import variables from '../../variables';
import './CondoDetail.scss';
import './TabsProfile.scss';
import CondoInfo from './CondoInfo';
import axios from 'axios';
import CondoDocuments from './CondoDocuments';
import { NumberParam, StringParam, withDefault } from 'serialize-query-params';
import { useQueryParams } from 'use-query-params';
import CondoAgreements from './CondoAgreements';
import CondoSubscriptions from './CondoSubscriptions';
import CondoFinancialReports from './CondoFinancialReports';
import CondoBalances from './CondoBalances';
const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

function CondosDetail(props) {
  const [
    { newToken, newIsAdmin, newUserType = '', profile = {} } = {},
  ] = useAuth();
  const [t] = useTranslation('CONDOS_DETAIL');
  const [pageBack, setPageBack] = useState('');
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();
  const { history, location, match = {} } = props;
  const { params: { id } = {}, url = '' } = match;
  const { pathname = '', state = {} } = location;
  const tab = pathname.split('/').pop();

  const [condo, setCondo] = useState({});

  const [assemblyActived, setAssemblyActived] = useState(() => {
    const saved = localStorage.getItem('assemblyActived');
    return saved === 'true';
  });

  function changeAssemblyMode() {
    const statusMode = assemblyActived;
    localStorage.setItem('assemblyActived', !statusMode);
    setAssemblyActived(!statusMode);
  }

  const restrictedTabs = [
    'subscriptions',
    'financial-reports',
    'variable-revenues',
    'variable-revenues-insurances',
    'variable-revenues-energy',
    'variable-revenues-recurrent-energy',
  ];

  if (assemblyActived && restrictedTabs.includes(tab)) {
    history.replace(`${match.url}/info`);
  }

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    active: withDefault(StringParam, localStorage.getItem('active')),
  });

  const { limit, offset, active } = query;

  function onFilter(queryDiff) {
    if (
      (queryDiff.active && queryDiff.active !== active) ||
      (active && queryDiff.active === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0;
    }
    setQuery(queryDiff);
  }

  const fetchCondo = async () => {
    if (tab === 'info') {
      showLoading();
    }
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/condos/detail/${id}`,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      hideLoading();

      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    if (tab === 'info') {
      hideLoading();
    }

    const { data = [] } = response;
    setCondo(data);
  };

  const fetchCertifiers = async (value) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/profiles/certifier`,
      {
        headers: { Authorization: newToken },
        params: { search: value },
      }
    );

    if (response instanceof Error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return [];
    }

    const { data = [] } = response;
    return data;
  };

  const fetchAdminCollabs = async (value) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/profiles/admin-collabs`,
      {
        headers: { Authorization: newToken },
        params: {
          search: value,
          adminId:
            condo.matchingAdmin.length > 0
              ? condo.matchingAdmin[0].id
              : condo.admins[condo.admins.length - 1].id,
        },
      }
    );

    if (response instanceof Error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return [];
    }

    const { data = [] } = response;
    return data;
  };

  useEffect(() => {
    fetchCondo();
  }, []);

  useEffect(() => {
    if (state.pageBack) setPageBack(state.pageBack);
  }, [state]);

  if (pathname === url) {
    return <Redirect to={`${url}/info`} />;
  }

  return (
    <div>
      <Row>
        <Col sm="12" md="6">
          <ContFlexLeft>
            <BtnRadiusWhite
              onClick={() => {
                if (newUserType === 'SUPER_ADMIN') {
                  history.replace(`/condos`);
                } else {
                  history.replace(`/my-condos`);
                }
              }}
            >
              <IconBack fill={variables.primary} />
            </BtnRadiusWhite>
            <H4Styled>{condo.name}</H4Styled>
          </ContFlexLeft>
        </Col>
      </Row>
      {!newIsAdmin && (
        <Row>
          <Button
            color="primary"
            style={{
              marginLeft: '1rem',
              fontSize: '14px',
              fontWeight: '600px',
              marginBottom: '15px',
            }}
            onClick={changeAssemblyMode}
          >
            {assemblyActived ? (
              <>
                {t('ASSEMBLY_ACTIVE')}{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 512"
                  width="25"
                  height="15"
                >
                  <path
                    fill="white"
                    d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"
                  />
                </svg>
              </>
            ) : (
              <>
                {t('ASSEMBLY_NOT_ACTIVE')}{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                  width="25"
                  height="15"
                >
                  <path
                    fill="white"
                    d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
                  />
                </svg>
              </>
            )}
          </Button>
        </Row>
      )}

      <div className="m-tb-20">
        <Nav tabs>
          <NavItem>
            <NavLink
              tag={Link}
              to={`${match.url}/info`}
              className={classNames({ active: tab === 'info' })}
            >
              {t('GENERAL_INFO')}
            </NavLink>
          </NavItem>

          {newIsAdmin && (
            <NavItem>
              <NavLink
                tag={Link}
                to={`${match.url}/balances`}
                className={classNames({ active: tab === 'balances' })}
              >
                {t('TABS:CONDO_BALANCES')}
              </NavLink>
            </NavItem>
          )}

          <NavItem>
            <NavLink
              tag={Link}
              to={`${match.url}/condo-documents`}
              className={classNames({ active: tab === 'condo-documents' })}
            >
              {t('TABS:CONDO_DOCUMENTS')}
            </NavLink>
          </NavItem>

          {profile.type !== 'CERTIFIER' && (
            <NavItem>
              <NavLink
                tag={Link}
                to={`${match.url}/agreements`}
                className={classNames({ active: tab === 'agreements' })}
              >
                {t('TABS:CONDO_AGREEMENTS')}
              </NavLink>
            </NavItem>
          )}

          {profile.type !== 'CERTIFIER' && !assemblyActived && (
            <NavItem>
              <NavLink
                tag={Link}
                to={`${match.url}/subscriptions`}
                className={classNames({ active: tab === 'subscriptions' })}
              >
                {t('TABS:CONDO_SUBSCRIPTION')}
              </NavLink>
            </NavItem>
          )}

          {profile.type !== 'CERTIFIER' && !assemblyActived && (
            <NavItem>
              <NavLink
                tag={Link}
                to={`${match.url}/financial-reports`}
                className={classNames({
                  active: [
                    'financial-reports',
                    'variable-revenues',
                    'variable-revenues-insurances',
                    'variable-revenues-energy',
                    'variable-revenues-recurrent-energy',
                  ].includes(tab),
                })}
              >
                {t('TABS:FINANCIAL_REPORTS')}
              </NavLink>
            </NavItem>
          )}
        </Nav>

        <Switch>
          <Route
            path={`${match.url}/info`}
            component={(props) => (
              <CondoInfo
                id={id}
                data={condo}
                fetchCertifiers={fetchCertifiers}
                fetchAdminCollabs={fetchAdminCollabs}
                fetchCondo={fetchCondo}
                {...props}
              />
            )}
          />

          <Route
            path={`${match.url}/condo-documents`}
            component={(props) => (
              <Card>
                <CardBody>
                  <CondoDocuments
                    profile={profile}
                    condo={condo}
                    query={query}
                    onFilter={onFilter}
                  ></CondoDocuments>
                </CardBody>
              </Card>
            )}
          />

          <Route
            path={`${match.url}/agreements`}
            component={(props) => (
              <Card>
                <CardBody>
                  <CondoAgreements
                    profile={profile}
                    data={condo}
                    assemblyActived={assemblyActived}
                  ></CondoAgreements>
                </CardBody>
              </Card>
            )}
          />

          {!assemblyActived && (
            <Route
              path={`${match.url}/subscriptions`}
              component={(props) => (
                <Card>
                  <CardBody>
                    <CondoSubscriptions
                      profile={profile}
                      condo={condo}
                      condoId={id}
                    ></CondoSubscriptions>
                  </CardBody>
                </Card>
              )}
            />
          )}

          {!assemblyActived && (
            <Route
              path={`${match.url}/financial-reports`}
              component={(props) => (
                <Card>
                  <CardBody>
                    <CondoFinancialReports
                      profile={profile}
                      id={id}
                      data={condo}
                      match={match}
                    ></CondoFinancialReports>
                  </CardBody>
                </Card>
              )}
            />
          )}

          <Route
            path={`${match.url}/balances`}
            component={(props) => (
              <Card>
                <CardBody>
                  <CondoBalances profile={profile} condoId={id}></CondoBalances>
                </CardBody>
              </Card>
            )}
          />
        </Switch>
      </div>
      <Footer />
    </div>
  );
}

export default CondosDetail;
